import ReducerRegistry from '../base/redux/ReducerRegistry';
import { callRoomReducer } from './callStage';
/**
 * The call-room steps behind the peer pane's stage line (callStage.ts).
 */
ReducerRegistry.register('features/vrs-layout', callRoomReducer);
